export const SITE = {
    name: "Frizerka – Hair by Tijana",
    short: "Frizerka",
    phone: "+49 151 23007554",
    phoneRaw: "+4915123007554",
    whatsapp: "https://wa.me/4915123007554",
    email: "frizerka96@gmail.com",
    instagram: "https://instagram.com/_frizerka_hairbytijana",
    instagramHandle: "@_frizerka_hairbytijana",
    address: {
        street: "Obere Riedstraße 52a",
        city: "68309 Mannheim",
        country: "Deutschland",
    },
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_513bc9a5-bcde-4d3e-a917-f9d422898175/artifacts/g4cmwm46_IMG_1876.jpeg",
    mapEmbed: "https://www.google.com/maps?q=Obere%20Riedstra%C3%9Fe%2052a%2068309%20Mannheim&hl=de&z=16&output=embed",
    hours: [
        { day: 0, open: "09:00 – 15:00" }, // Monday
        { day: 1, open: null },             // Tuesday
        { day: 2, open: "09:00 – 15:00" },
        { day: 3, open: "09:00 – 15:00" },
        { day: 4, open: "09:00 – 15:00" },
        { day: 5, open: "09:00 – 15:00" },
        { day: 6, open: null },             // Sunday
    ],
    images: {
        hero: "https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80",
        about: "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/tz2jwck4_08892af6-86ae-4948-b4b6-88343ed0217d.jpeg",
        services: [
            "https://images.pexels.com/photos/4584413/pexels-photo-4584413.jpeg",
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/6o69hjyb_IMG_1999.jpeg",
            "https://images.unsplash.com/photo-1634449571010-02389ed0f9b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb24lMjB3YXNoaW5nJTIwaGFpcnxlbnwwfHx8fDE3ODMxNTIwNzN8MA&ixlib=rb-4.1.0&q=85",
        ],
        gallery: [
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/4niqyede_1d668253-629e-42e7-8fc0-072fe69a1041.jpeg",
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/jxiqmket_IMG_2002.jpeg",
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/nolnzigp_IMG_1718.webp",
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/9i7t5l11_191903e8-7f44-436a-b88c-e6dfd23221cb.jpeg",
            "https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg",
            "https://customer-assets-jt897jd0.emergentagent.net/job_frizerka-preview/artifacts/rc89xuu8_03beff0d-54bb-47c0-b177-0513d55070d1.jpeg",
        ],
    },
};
